let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: id === "inicio" ? -200 : -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const goToContact = (projectType) => {
  if (projectType) window.dispatchEvent(new CustomEvent("ws:prefill", { detail: projectType }));
  scrollToId("contato");
};
